import Client from "../client";

export class ReservedIssue {
  static async reservePeriodList(filter: any) {
    return await Client.get<any[]>(`/reservedIssue/period`, filter);
  }
}
